import type { Tag } from "../types";
import { getTagColorStyles } from "../colors";
import IconRecycleBinThrow from "@/components/icons/icon-recycle-bin-throw";
import IconHandHeldTablet from "@/components/icons/icon-hand-held-tablet";

export interface TagListItemProps {
	tag: Tag;
	onDelete?: (id: string, workspaceId: string) => void;
	onEdit?: (tag: Tag) => void;
	workspaceId: string;
}

export default function TagListItem({ tag, onDelete, onEdit, workspaceId }: TagListItemProps) {
	const colorStyles = getTagColorStyles(tag.color);

	return (
		<div className="group flex items-center justify-between gap-4 p-4 bg-white rounded-xl border border-gray-200 hover:shadow-sm hover:border-gray-300 transition-all">
			<div className="flex items-center gap-2 flex-1 min-w-0">
				<span className={`w-4 h-4 rounded shrink-0 ${colorStyles.bg} ${colorStyles.border || ""}`} />
				<span className="font-medium text-gray-900 text-sm shrink-0">{tag.label}</span>
				{tag.description && <span className="text-sm text-tertiary truncate">{tag.description}</span>}
			</div>
			<div className="flex items-center gap-3">
				{tag.aggr_reviews_count != null && tag.aggr_reviews_count > 0 && (
					<span className="text-xs text-tertiary shrink-0">
						{tag.aggr_reviews_count} {tag.aggr_reviews_count === 1 ? "review" : "reviews"}
					</span>
				)}
				<div className="flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
				{onEdit && (
					<button className="p-1 text-gray-400 hover:text-brand hover:bg-gray-100 rounded transition-colors cursor-pointer" onClick={() => onEdit(tag)} aria-label="Edit tag">
						<IconHandHeldTablet className="w-4 h-4" />
					</button>
				)}
				{onDelete && (
					<button
						onClick={() => onDelete(tag.id, workspaceId)}
						className="p-1 text-gray-400 hover:text-red-500 hover:bg-red-50 rounded transition-colors cursor-pointer"
						aria-label="Delete tag"
					>
						<IconRecycleBinThrow className="w-4 h-4" />
					</button>
				)}
				</div>
			</div>
		</div>
	);
}
